import React from "react";
import { Box, Flex, H3, Text } from "ui-components";
import { COLORS, iconThemes } from "ui-components/theme";
import get from "lodash/get";
import FormattedMessage from "../FormattedMessage";
import isEmpty from "lodash/isEmpty";
import { PHONEONLY_PARAM_SOURCE } from "utils/constants";
import { urlParam } from "utils/helpers";

const PayDeviceCard = ({ data, themeColors, selectedPhone }) => {
  if (isEmpty(selectedPhone)) return null;
  const { primaryColor: primary, secondaryColor: secondary } = data || {};
  const { paymentType, paymentTerm, label, paymentOption } = selectedPhone;
  const defaultColor = get(themeColors, "primary") || iconThemes.blue;
  const iconColor = get(themeColors, "icon") || iconThemes.blue;
  const source = urlParam("source");

  const title = () => {
    if (paymentType === "full") {
      return (
        <Text fontWeight="bold" py="4px">
          <FormattedMessage id={get(data, "fullPayment", "full_payment")} />
        </Text>
      );
    }
    return (
      <Text fontWeight="bold" py="4px">
        {paymentTerm}{" "}
        <FormattedMessage
          id={get(data, "installmentPayment", "installment_payment")}
        />
      </Text>
    );
  };

  const primaryColor = primary ? iconThemes[primary] || primary : defaultColor;
  const secondaryColor = secondary
    ? iconThemes[secondary] || secondary
    : defaultColor;
  const { originalTransactionAmount, original_price, discount } = get(
    paymentOption,
    paymentType,
    {}
  );
  const borderWidth = get(data, "borderWidth", 6);
  return (
    <Box
      variant="borderSection"
      mb={8}
      padding={[0, 0]}
      paddingBottom={"20px"}
      sx={{
        color: primaryColor,
        borderColor: primaryColor,
        borderWidth
      }}
    >
      <Box mb={5}>
        <Flex
          py={1}
          justifyContent="space-between"
          alignItems="center"
          backgroundColor={secondaryColor}
          px={"1rem"}
        >
          <Box paddingRight={1} justifySelf="flex-start" flex={1}>
            <H3>
              <Text fontWeight="bolder" py="4px" color={COLORS.white}>
                <FormattedMessage id={get(data, "title", "pay_device")} />
              </Text>
            </H3>
          </Box>
        </Flex>
      </Box>
      <Flex
        py={1}
        justifyContent="space-between"
        alignItems="flex-start"
        px={"1rem"}
      >
        <Box paddingRight={1} justifySelf="flex-start" pb={2}>
          {title()}
        </Box>
        {paymentType === "installment" && (
          <Text py="4px" fontWeight="bold" color={iconColor}>
            {originalTransactionAmount}
          </Text>
        )}
      </Flex>
      <Flex
        pt={1}
        justifyContent="space-between"
        alignItems="flex-start"
        px={"1rem"}
      >
        <Box paddingRight={1} justifySelf="flex-start" flex={1}>
          <Text fontWeight="bold" py="4px" color={COLORS.gray[3]}>
            {label}
          </Text>
        </Box>
        <Box width={["fit-content"]}>
          <Text fontWeight="bold" py="4px" color={iconColor}>
            {paymentType === "installment"
              ? `$${original_price} in ${paymentTerm}mo`
              : originalTransactionAmount}
          </Text>
        </Box>
      </Flex>
      {discount > 0 && (
        <Flex
          justifyContent="space-between"
          alignItems="center"
          pb={3}
          px={"1rem"}
        >
          <Box paddingRight={1} justifySelf="flex-start" flex={1}>
            <Text py="4px" color={COLORS.gray[1]}>
              {source === PHONEONLY_PARAM_SOURCE.EARN_AND_BURN ? (
                <FormattedMessage
                  id={get(data, "enbDiscountLabel", "Discount")}
                />
              ) : (
                "Discount"
              )}
            </Text>
          </Box>
          <Box width={["fit-content"]}>
            <Text py="4px" color={COLORS.gray[1]}>
              {`-$${discount}`}
            </Text>
          </Box>
        </Flex>
      )}
    </Box>
  );
};

PayDeviceCard.defaultProps = {
  selectedPhone: {}
};

export default PayDeviceCard;
